import ListAddress from "../components/Address/ListAddress";

const AddressPage = () => {
    return (
        <ListAddress/>
    )
}
export default AddressPage